//@ts-nocheck
import Vue from "vue";
import store from "../store";

Vue.filter("zeroNull", (v) => v || 0);
Vue.filter("stripNull", (v) => v || "-");
Vue.filter("falseNull", (v) => v || false);
Vue.filter("formatCurrency", formatCurrency);
Vue.filter("formatDecimal", formatDecimal);
Vue.filter("formatShorten", formatShorten);
Vue.filter("formatNumber", (value) => {
  const local = store.state.app.local;
  if (!value) {
    return "-";
  }
  if(local.code === "ID") {
    const temp = value.toLocaleString();
    return temp.indexOf(local.decimal_separator) > -1 ? temp.substring(0, temp.indexOf(local.decimal_separator)) : temp;
  }
  const temp = value.toLocaleString(local.code);
  const decimalSeparatorIndex = temp.indexOf(local.decimal_separator);
  const length = temp.length;
  let formattedValue = temp;
  if (decimalSeparatorIndex != -1) {
    const usedIndex = decimalSeparatorIndex + 3;
    if (length > usedIndex) {
      formattedValue = temp.substring(0, usedIndex);
    }
  }
  return formattedValue;
});

/**
 * Returns the currency formatted accordingly
 */
export function formatCurrency(value, currency) {
  currency = currency || store.state.app.currency;
  return formatPrice(value, currency);
}

export function formatDecimal(value, currency) {
  currency = currency || store.state.app.currency;
  return formatPrice(value, currency, false);
}

/**
* Returns the price passed formatted according to the system configurations for the currency
*
* @param price
* @returns {*}
*/
export function formatPrice(price, currency, useSymbol = true) {
  currency.currencySymbol = store.state.app.hotel.currency_symbol;
  try {
    const numberFormatted = numberFormat(
      price,
      currency.decimalDigits,
      currency.decimalSeparator,
      currency.thousandsSeparator
    );

    if (currency.currencySymbol && useSymbol) {
      const priceSeparator = currency.currencySymbolNumberOfSpaces > 0
        ? " ".repeat(currency.currencySymbolNumberOfSpaces)
        : "";
      let priceParts = [numberFormatted, priceSeparator, currency.currencySymbol];

      if (currency.currencySymbolPosition === "left") {
        priceParts = priceParts.reverse();
      }

      return priceParts.join("");
    } else {
      return numberFormatted;
    }
  } catch (e) {
    return price;
  }
}

/**
   * Helper method to format a number given a few configurations such as the separation
   * between thousands and decimals
   *
   * @param number
   * @param decimals
   * @param dec_point
   * @param thousands_sep
   * @returns {*}
   */
export function numberFormat(number, decimals, dec_point, thousands_sep) {
  if (isNaN(number)) {
    return number;
  }
  const negative = number < 0;
  if (negative) number = number * -1;
  const fixed = number.toFixed(decimals ? decimals : 0);
  const str = fixed.toString().split(".");
  const parts = [];

  for (let i = str[0].length; i > 0; i -= 3) {
    parts.unshift(str[0].substring(Math.max(0, i - 3), i));
  }

  str[0] = parts.join(thousands_sep ? thousands_sep : ",");

  // Derive the sign from the rounded magnitude, not the raw input: a value
  // that rounds to zero (e.g. -0.001 at 2dp, -0.4 at 0dp) must render "0"/
  // "0.00", never a stray "-0".
  const isZero = Number(fixed) === 0;
  return (negative && !isZero ? "-" : "") + str.join(dec_point ? dec_point : ".");
}

export function formatShorten(num, digits = 3) {
  const si = [
    { value: 1, symbol: "" },
    { value: 1E3, symbol: "k" },
    { value: 1E6, symbol: "M" },
    { value: 1E9, symbol: "G" },
    { value: 1E12, symbol: "T" },
    { value: 1E15, symbol: "P" },
    { value: 1E18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

export default {
  formatPrice,
  numberFormat
};
